module.exports = __webpack_public_path__ + "img/852e03c.png";